
import { Options, Vue } from 'vue-class-component'
// import router from '../../../ddu-frontend-ts-app/src/router/index'
import { admZubPth } from '@/components/Utility/aXdYmZ'

export default class adminSidebar extends Vue {
  hjZpAlq = admZubPth.toString()
}
